import { render, staticRenderFns } from "./DomaineCard.vue?vue&type=template&id=1cbf257a&scoped=true&"
import script from "./DomaineCard.vue?vue&type=script&lang=js&"
export * from "./DomaineCard.vue?vue&type=script&lang=js&"
import style0 from "./DomaineCard.vue?vue&type=style&index=0&id=1cbf257a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbf257a",
  null
  
)

export default component.exports